(function() {
  'use strict';

  var MIN_CHARS = 2;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents);
    }
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function collectShownIds(grid) {
    var shown = {};
    grid.querySelectorAll('.cmgp-product-card[data-product-id], .cmgp-wishlist-btn[data-product-id]').forEach(function(el) {
      var id = el.getAttribute('data-product-id');
      if (id) shown[id] = true;
    });
    return shown;
  }

  function buildCard(product) {
    var img = product.images && product.images[0] ? product.images[0].src : '';
    var variant = product.variants && product.variants[0] ? product.variants[0] : null;
    var priceCents = variant ? Math.round(Number(variant.price) * 100) : 0;
    var url = root() + 'products/' + product.handle;

    return (
      '<div class="cmgp-product-item" data-search-expanded="true">' +
        '<div class="cmgp-product-card" data-product-id="' + product.id + '">' +
          '<button class="cmgp-wishlist-btn" type="button" data-product-id="' + product.id + '" aria-label="Add to wishlist">' +
            '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>' +
          '</button>' +
          '<a href="' + url + '" class="cmgp-product-link">' +
            '<div class="cmgp-product-image-wrapper">' +
              (img
                ? '<img src="' + img + '" alt="" class="cmgp-product-image cmgp-image-primary" loading="lazy" width="600" height="600">'
                : '<div class="cmgp-product-placeholder"><svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor"><rect x="3" y="3" width="18" height="18" rx="2"/></svg></div>') +
            '</div>' +
            '<div class="cmgp-product-info">' +
              '<h3 class="cmgp-product-title">' + escapeHtml(product.title) + '</h3>' +
              '<div class="cmgp-product-price" data-cmgp-price-wrap data-variant-id="' + (variant ? variant.id : '') + '">' +
                '<span class="cmgp-price-current" data-cmgp-sale-price>' + formatMoney(priceCents) + '</span>' +
              '</div>' +
            '</div>' +
          '</a>' +
        '</div>' +
      '</div>'
    );
  }

  function getStatusEl() {
    return document.querySelector('[data-search-expand-status]');
  }

  function setStatus(grid, message) {
    var el = getStatusEl();
    if (!el) return;
    if (!message) {
      el.hidden = true;
      el.textContent = '';
      return;
    }
    el.hidden = false;
    el.textContent = message;
  }

  function updateResultCount(grid) {
    var count = grid.querySelectorAll('.cmgp-product-item').length;
    var countEl = document.querySelector('[data-search-result-count]');
    if (countEl) {
      countEl.textContent = count + (count === 1 ? ' product' : ' products');
      countEl.hidden = count === 0;
    }
    var noResults = document.querySelector('[data-search-no-results]');
    if (noResults) noResults.hidden = count > 0;
    setStatus(grid, '');
  }

  function whenSkuReady(callback, attempt) {
    attempt = attempt || 0;
    if (window.SearchSkuSuggestions && typeof window.SearchSkuSuggestions.searchAll === 'function') {
      callback();
      return;
    }
    if (attempt >= 60) {
      callback(true);
      return;
    }
    window.setTimeout(function() {
      whenSkuReady(callback, attempt + 1);
    }, 100);
  }

  function expandSearchResults() {
    var grid = document.querySelector('[data-search-expand-grid]');
    if (!grid) return;

    var catalogHandle = grid.getAttribute('data-search-collection') || 'all-jewelry';
    var query = (grid.getAttribute('data-search-query') || '').trim();
    if (window.SearchSkuSuggestions && typeof window.SearchSkuSuggestions.primaryQuery === 'function') {
      query = window.SearchSkuSuggestions.primaryQuery(query);
    } else {
      query = String(query).split(/\s+or\s+/i)[0].trim();
    }
    if (!query || query.length < MIN_CHARS) return;

    setStatus(grid, 'Loading all matching products...');

    whenSkuReady(function(fallbackMode) {
      if (!fallbackMode && window.SearchSkuSuggestions) {
        window.SearchSkuSuggestions.searchAll(query, { collectionHandle: catalogHandle })
          .then(function(products) {
            var shown = collectShownIds(grid);
            var html = '';
            (products || []).forEach(function(product) {
              var id = String(product.id);
              if (shown[id]) return;
              shown[id] = true;
              html += buildCard(product);
            });
            if (html) grid.insertAdjacentHTML('beforeend', html);
            updateResultCount(grid);
            if (typeof window.initCmgpCollectionDiscountPrices === 'function') {
              window.initCmgpCollectionDiscountPrices(grid);
            }
          })
          .catch(function() {
            updateResultCount(grid);
          });
        return;
      }

      setStatus(grid, '');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', expandSearchResults);
  } else {
    expandSearchResults();
  }
})();
